export const exportTypes = (command: (type: number) => void) => [
    {
      label: 'Excel',
      command: () => { command(0); }
    },
    {
      label: 'CSV',
      command: () => { command(1); }
    },
    {
      label: 'PDF',
      command: () => { command(2); }
    },
  ];
  